module.exports = __webpack_public_path__ + "media/customizations/serranoeldorado/back-a56ad886779ec3247ca4d635008f021a.jpg";